<template>
    <div id="stackedcolumnchart" v-if="chartData"></div>
</template>

<script>
	import * as am4core from "@amcharts/amcharts4/core"
	import * as am4charts from "@amcharts/amcharts4/charts"
	import am4themes_animated from "@amcharts/amcharts4/themes/animated"
    am4core.useTheme(am4themes_animated)
    
    export default {
        name: 'stacked-columns-chart',
        props: {
            chartData: Array,
        },
        
		data() {
			return {
                chart: null,
			}
		},
        mounted() {
            this.initialize()
        },
        methods: {
            initialize() {
                if (this.chart) {
                    this.chart.dispose();
                }
                this.chart = am4core.create("stackedcolumnchart", am4charts.XYChart)
                this.chart.data = this.chartData
                this.chart.height = 600
                let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
                categoryAxis.dataFields.category = "month"
                categoryAxis.title.text = "Utenti"
                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis())
                valueAxis.renderer.inside = true
                valueAxis.title.text = "Appuntamenti"
                valueAxis.title.calculateTotals  = true
                this.chart.responsive.enabled = true;
                let series_name = {}
                _.forEach(this.chartData, (value) => {
                    _.forEach(value, (key, serie) => {
                        if(serie != 'month') {
                            series_name[serie] = serie
                        }
                    })
                })
                
                _.forEach(series_name, (name) => {
                    this.createSeries(name, name)
                })
                // Legend
                this.chart.legend = new am4charts.Legend()
                this.chart.legend.contentAlign = 'center'
                this.chart.legend.itemContainers.template.paddingTop = 15
                this.chart.scrollbarY = new am4core.Scrollbar();
            },

            createSeries(field, name) {
                // Set up series
                let series = this.chart.series.push(new am4charts.ColumnSeries())
                series.name = name
                series.dataFields.valueY = field
                series.dataFields.categoryX = "month"
                series.sequencedInterpolation = true
                
                // Make it stacked
                series.stacked = true
                
                // Configure columns
                series.columns.template.width = am4core.percent(80)
                series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:12px]{categoryX}: {valueY}"
                series.columns.template.column.fillOpacity = 0.8
                series.columns.template.column.cornerRadiusTopLeft = 10
                series.columns.template.column.cornerRadiusTopRight = 10
                series.columns.template.column.cornerRadiusBottomLeft = 10
                series.columns.template.column.cornerRadiusBottomRight = 10
                // Add label
                let labelBullet = series.bullets.push(new am4charts.LabelBullet())
                labelBullet.label.text = "[font-size:12px]{valueY}"
                labelBullet.locationY = 0.5
                series.legendSettings.labelText = '[font-size:12px text-transform: capitalize]{name}'
                
                
                return series;
            }
        },
        beforeDestroy() {
            if (this.chart) {
                this.chart.dispose();
            }
        },
        watch: {
			chartData: {
				handler() {
                    this.initialize()
				},
				deep: true
            },
        }
    }
</script>

<style>
	g[opacity|="0.4"][aria-labelledby|="id"] {
  		display: none;
	}
    #stackedcolumnchart {
        min-height: 600px
    }
</style>